// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// const seenKeys = new Set();

// const resources = {
//   en: {
//     translation: {
//       "NATIONAL GAMES": "NATIONAL GAMES",
//     },
//   },
//   hi: {
//     translation: {
//       "NATIONAL GAMES": "राष्ट्रीय खेल",
//     },
//   },
// };

// i18n.use(initReactI18next).init({
//   resources,
//   lng: "en", // default language
//   fallbackLng: "en",
//   interpolation: {
//     escapeValue: false,
//   },
// });
// // Capture texts
// const originalT = i18n.t.bind(i18n);
// i18n.t = (key, options) => {
//   seenKeys.add(key);
//   return originalT(key, options) || key;
// };

// // Utility to get all collected keys
// export function getCollectedTexts() {
//   return Array.from(seenKeys);
// }
// export default i18n;
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import hi from "./locales/hi/translation.json";
const seenKeys = new Set();
i18n
  .use(LanguageDetector) // detects browser or stored language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });
const originalT = i18n.t.bind(i18n);
i18n.t = (key, options) => {
  seenKeys.add(key);
  return originalT(key, options) || key;
};
export function getCollectedTexts() {
  return Array.from(seenKeys);
}
export default i18n;
